/*

	YH: Data Spread Sheet is Here
    https://docs.google.com/spreadsheets/d/1qv9BXpEhA5Xodaoq52PTWGO455vFbi1IKFF8aqwpUIY/edit?usp=sharing

*/
export const SelectLayoutsVisual = [

    {
    	id: '1',
    	color: 'bk',
    },
    {
    	id: '2',
    	color: 'wh',
    },
    {
    	id: '3',
    	color: 'bk',
    },
    {
    	id: '4',
    	color: 'wh',
    },

];

